import { useState, useEffect } from 'react';
import { Outlet, NavLink, useNavigate } from 'react-router-dom';
import { useAuthStore } from '../../store/authStore';
import { cn } from '../../lib/utils';
import { LayoutDashboard, Package, ClipboardList, LogOut, Menu, X, Settings } from 'lucide-react';
import { Button } from '../ui/button';
import FloatingChatWidget from '../FloatingChatWidget';

const navigation = [
  { name: 'Gösterge Paneli', href: '/albumcu', icon: LayoutDashboard, end: true },
  { name: 'Ürünlerim', href: '/albumcu/urunler', icon: Package },
  { name: 'Gelen Siparişler', href: '/albumcu/siparisler', icon: ClipboardList },
  { name: 'Ayarlar', href: '/albumcu/ayarlar', icon: Settings },
];

export default function AlbumcuLayout() {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const { user, logout } = useAuthStore();
  const navigate = useNavigate();

  useEffect(() => {
    if (user && user.user_type !== 'albumcu') {
      navigate('/');
    }
  }, [user]);

  const handleLogout = () => { logout(); navigate('/giris'); };

  return (
    <div className="min-h-screen flex bg-slate-50">
      {/* Sidebar */}
      <aside className={cn(
        'fixed inset-y-0 left-0 z-40 w-60 bg-white border-r transition-transform lg:translate-x-0',
        sidebarOpen ? 'translate-x-0' : '-translate-x-full'
      )}>
        <div className="p-4 border-b">
          <div className="flex items-center justify-between">
            <div>
              <div className="font-bold text-primary">Albümcü Paneli</div>
              <div className="text-[10px] text-slate-500 truncate">{user?.company_name || user?.full_name}</div>
            </div>
            <Button variant="ghost" size="icon" className="lg:hidden" onClick={() => setSidebarOpen(false)}>
              <X className="h-4 w-4" />
            </Button>
          </div>
        </div>
        <nav className="p-3 space-y-1">
          {navigation.map(item => (
            <NavLink key={item.href} to={item.href} end={item.end}
              onClick={() => setSidebarOpen(false)}
              className={({ isActive }) => cn(
                'flex items-center gap-2 px-3 py-2 rounded-lg text-sm transition',
                isActive ? 'bg-primary text-white' : 'text-slate-700 hover:bg-slate-100'
              )}
              data-testid={`nav-${item.href.split('/').pop() || 'home'}`}>
              <item.icon className="h-4 w-4" />{item.name}
            </NavLink>
          ))}
        </nav>
        <div className="absolute bottom-0 inset-x-0 p-3 border-t">
          <Button variant="ghost" className="w-full justify-start text-red-600" onClick={handleLogout}>
            <LogOut className="h-4 w-4 mr-2" />Çıkış
          </Button>
        </div>
      </aside>

      <main className="flex-1 lg:ml-60">
        <header className="bg-white border-b p-3 flex items-center gap-2 lg:hidden">
          <Button variant="ghost" size="icon" onClick={() => setSidebarOpen(true)}>
            <Menu className="h-5 w-5" />
          </Button>
          <div className="font-bold">Albümcü Paneli</div>
        </header>
        <div className="p-4 md:p-6 max-w-6xl mx-auto">
          <Outlet />
        </div>
      </main>

      {/* Floating Chat Widget */}
      <FloatingChatWidget />
    </div>
  );
}
